import { init } from 'src/fancy/falling-confetti/app2'
import { hexToObj } from 'src/utils/Color'

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('hearts-confetti')
  const colors = JSON.parse(canvas.dataset.colors)
  .map(color => Object.values(hexToObj(color)))

  const start = () => init(canvas, { colors })
  let stop = start()
  const restart = () => {
    stop()
    stop = start()
  }

  document.addEventListener('dblclick', e => {
    if (e.target.closest('.footer .copyright')) {
      canvas.doMouseStuff = !canvas.doMouseStuff
      restart()
    }
  })
})
